const UPLOAD_FILE_SIZE_LIMIT = 1024 * 1024 * 5000 // 5GB limit

const FILE_UPLOAD_INTERRUPTED_MESSAGE = 'File upload interrupted'
export { UPLOAD_FILE_SIZE_LIMIT, FILE_UPLOAD_INTERRUPTED_MESSAGE }